import React from "react";

const TextProgress = ({ value, type }) => {
  const minScore = 0; // min
  const maxScore = 10; // max

  const clampedValue = Math.min(maxScore, Math.max(minScore, parseFloat(value) || 0));

  const percentage = ((clampedValue - minScore) / (maxScore - minScore)) * 100;

  // Define SVG dimensions and arc properties
  const svgWidth = 160;
  const svgHeight = 100;
  const viewBox = `0 0 ${svgWidth} ${svgHeight}`;

  const arcRadius = 60; 
  const arcCenterY = 80; 
  const arcStartX = 20;
  const arcEndX = 140;
  const arcCenterX = (arcStartX + arcEndX) / 2;

  const strokeWidth = 20; // width of the curve

  const arcLength = Math.PI * arcRadius;

  // Gradient colors
  const gradientId = `progressGradient-${type}`;

  // needle rotation logic 
  const needleAngleDegrees = 180 - (percentage / 100) * 180;
  const needleAngleRadians = needleAngleDegrees * Math.PI / 180;
  const pointerRadius = arcRadius - strokeWidth / 2;
  const baseRadius = 5; 
  const baseWidth = 8;  
  const tipWidth = 0;  

  // Calculate the coordinates for the needle's tip
  const tipPointX = arcCenterX + pointerRadius * Math.cos(needleAngleRadians);
  const tipPointY = arcCenterY - pointerRadius * Math.sin(needleAngleRadians); // SVG Y-axis is inverted

  const baseAngleOffset = Math.PI / 2; // 90 degrees in radians

  // Point for the base, slightly behind the center, or just at the center
  const centerBaseX = arcCenterX - baseRadius * Math.cos(needleAngleRadians);
  const centerBaseY = arcCenterY + baseRadius * Math.sin(needleAngleRadians);

  // Calculate the two outer base points for the wider part
  const baseX1 = centerBaseX + (baseWidth / 2) * Math.cos(needleAngleRadians + baseAngleOffset);
  const baseY1 = centerBaseY - (baseWidth / 2) * Math.sin(needleAngleRadians + baseAngleOffset);

  const baseX2 = centerBaseX + (baseWidth / 2) * Math.cos(needleAngleRadians - baseAngleOffset);
  const baseY2 = centerBaseY - (baseWidth / 2) * Math.sin(needleAngleRadians - baseAngleOffset);

  const needlePathData = `
    M ${tipPointX} ${tipPointY}
    L ${baseX1} ${baseY1}
    L ${baseX2} ${baseY2}
    Z
  `;

  return (
    <div className="flex flex-col items-center p-2">
      <div className="relative flex justify-center">
        <svg width={svgWidth} height={svgHeight} viewBox={viewBox}>
          <defs>
            <linearGradient
              id={gradientId}
              x1={arcStartX}
              y1={arcCenterY}
              x2={arcEndX}
              y2={arcCenterY}
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0%" stopColor="#FFB6C1" /> {/* Light Pink */}
              <stop offset="50%" stopColor="#FFD700" /> {/* Gold */}
              <stop offset="100%" stopColor="#90EE90" /> {/* Light Green */}
            </linearGradient>
          </defs>

          {/* Background Arc */}
          <path
            d={`M ${arcStartX} ${arcCenterY} A ${arcRadius} ${arcRadius} 0 0 1 ${arcEndX} ${arcCenterY}`}
            fill="none"
            stroke="#E3E7FF"
            strokeWidth={strokeWidth}
            strokeLinecap="butt"
          />

          {/* Progress Arc (full gradient fill) */}
          <path
            d={`M ${arcStartX} ${arcCenterY} A ${arcRadius} ${arcRadius} 0 0 1 ${arcEndX} ${arcCenterY}`}
            fill="none"
            stroke={`url(#${gradientId})`}
            strokeWidth={strokeWidth}
            strokeDasharray={`${arcLength} 0`}
            strokeLinecap="butt"
          />

          {/* Needle - Now a dynamically calculated Path (tapered) */}
          <path
            d={needlePathData}
            fill="#333"
            style={{ transition: 'd 0.5s ease-in-out' }} // Animate the path data itself
          />

          {/* Small circle at the pivot point for aesthetics */}
          <circle
            cx={arcCenterX}
            cy={arcCenterY}
            r="4" // Radius of the pivot circle
            fill="#333"
          />
        </svg>
      </div>
    </div>
  );
};

export default TextProgress;